var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7518 5.01848H6.44657V0.714045C6.44657 0.524669 6.37134 0.343049 6.23743 0.209139C6.10352 0.0752299 5.9219 0 5.73253 0C5.54315 0 5.36153 0.0752299 5.22762 0.209139C5.09371 0.343049 5.01848 0.524669 5.01848 0.714045V5.01932H0.714045C0.524669 5.01932 0.343049 5.09455 0.209139 5.22846C0.0752299 5.36237 0 5.54399 0 5.73337C0 5.92274 0.0752299 6.10436 0.209139 6.23827C0.343049 6.37218 0.524669 6.44741 0.714045 6.44741H5.01932V10.7527C5.01932 10.9421 5.09455 11.1237 5.22846 11.2576C5.36237 11.3915 5.54399 11.4667 5.73337 11.4667C5.92274 11.4667 6.10436 11.3915 6.23827 11.2576C6.37218 11.1237 6.44741 10.9421 6.44741 10.7527V6.44657H10.7527C10.9421 6.44657 11.1237 6.37134 11.2576 6.23743C11.3915 6.10352 11.4667 5.9219 11.4667 5.73253C11.4667 5.54315 11.3915 5.36153 11.2576 5.22762C11.1237 5.09371 10.9412 5.01848 10.7518 5.01848Z",
    fill: "#747478"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon2);
export default __webpack_public_path__ + "static/media/add-icon2.178209d400027c3d875895a8b4142fbb.svg";
export { ForwardRef as ReactComponent };